module.exports = __webpack_public_path__ + "img/exam_jan_2025_xbtb8f88.51853cc6.jpg";